import HeaderPage from "../components/HeaderPage";
import DeliveryAddress from "../../../rest/jtmc/models/DeliveryAddress";
import Map from "../../../components/custom-components/Map";
import {TextInputLabeled} from "../components/TextInput";
import {ColumnSpace} from "../components/_CommonComponents";
import Button from "../components/Button";
import AddressEditComponents from "../../../components/functional-components/AddressEditComponents";

export default function AddressEditor(props: any) {

    let {addressModel}: { addressModel: DeliveryAddress } = props.route.params ?? null;

    return <HeaderPage title={"افزودن آدرس"} scrollableContent={true}>
        <AddressEditComponents inputAddress={addressModel}>

            <Map role="map" width={"100%"} height={300}/>
            <ColumnSpace h={20}/>

            <TextInputLabeled containerStyle={{paddingHorizontal: 10}} role="input-title"/>
            <ColumnSpace h={12}/>

            <TextInputLabeled containerStyle={{paddingHorizontal: 10}} role="input-name"/>
            <ColumnSpace h={12}/>

            <TextInputLabeled containerStyle={{paddingHorizontal: 10}} role="input-phone"/>
            <ColumnSpace h={12}/>

            <TextInputLabeled containerStyle={{paddingHorizontal: 10}} role="input-address"/>
            <ColumnSpace h={12}/>

            <Button style={{marginHorizontal: 10}} role="button-save"/>
            <ColumnSpace h={12}/>

        </AddressEditComponents>
    </HeaderPage>
}

